import { useEffect, useState } from 'react'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { Button, Stack } from '@mui/material'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { activeClassForLr } from './helper'
import { useAtom } from 'jotai'
import { alertAtom, modalAtom } from './jotaiState/globalStateAtoms'
import { paymentTypeColor, urls } from './constants'
import useToken from '../helpers/useTokens'
import { PostRequest } from './api'
import { useTranslation } from '../../i18n/I18nProvider'

export const LrModalUI = ({ dataList }) => {
  const { translations } = useTranslation()
  const cs = translations.common
  const rs = translations.receive
  const [, setAlert] = useAtom(alertAtom)
  const [, setModal] = useAtom(modalAtom)
  const { loginData } = useToken()
  const [selectId, setSelectId] = useState(null)
  const [filterValues, setFilterValues] = useState({})
  const [filteredData, setfilteredData] = useState(dataList)
  const columnDefs = [
  {
    headerName: rs.select,
    field: 'Select',
    showfilter: false,
  },
  {
    headerName: rs.lrNo,
    field: 'LRNo',
  },
  {
    headerName: rs.lrNoFormat,
    field: 'FormattedLRNo',
  },
  {
    headerName: rs.lrNoManual,
    field: 'ManualLRNo',
  },
  {
    headerName: cs.status,
    field: 'LRStatus',
  },
  {
    headerName: rs.currentCity,
    field: 'CurrentCity',
  },
  {
    headerName: rs.bookingDateAndTime,
    field: 'BookingDateTime',
  },
  {
    headerName: cs.paymentType,
    field: 'PaymentTypeDet',
  },
  {
    headerName: rs.senderName,
    field: 'Sender',
  },
  {
    headerName: rs.receiverName,
    field: 'RecName',
  },
  {
    headerName: rs.source,
    field: 'FromCity',
  },
  {
    headerName: rs.destination,
    field: 'ToCity',
  },
]
  useEffect(() => {
    setfilteredData(dataList)
  }, [dataList])
  useEffect(() => {
    const filteredDataTemp = dataList.filter((item) => {
      return columnDefs.every((column) => {
        const filterValue = filterValues[column.field] || ''
        const value = item[column.field]
        return filterValue ? value && value.toString().toLowerCase().includes(filterValue.toLowerCase()) : true
      })
    })
    setfilteredData(filteredDataTemp)
  }, [filterValues])
  const handleChangeContain = (e, name) => {
    let value = e.target.value
    setFilterValues((prevFilterValues) => ({
      ...prevFilterValues,
      [name]: value,
    }))
  }
  const SelectLrForDelivery = () => {
    if (!selectId) {
      setAlert({ show: true, msg: rs.selectLRNO, nextId: '' })
    } else {
      const selectRecord = dataList.find((data) => data.BookingId === selectId)
      const data = {
        strBookingIDs: selectRecord.BookingId,
        strDipatchIDs: selectRecord?.DispatchID || 0,
        intNewCityID: loginData.intBranchCityID,
        intNewBranchID: loginData.intBranchID,
        intUserID: loginData.intUserID,
        intCompanyID: loginData.intCompanyID,
        intIsApp: 2,
      }
      PostRequest(urls.getReceiveSecond, data).then((res) => {
        if (res.status === 'Success') {
          setAlert({ show: true, msg: rs.lrReceivedSuccessfully,success: true, nextId: '' })
        }else{
          setAlert({ show: true, msg: rs.lrReceiveFailed, nextId: '' })
        }
      })
      setModal(false)
    }
  }
  const close = () => {
    setModal(false)
  }
  return (
    <>
      <Stack sx={{ minHeight: 500, minWidth: 650 }}>
        <TableContainer className="lr-popup-table lrModel" component={Paper}>
          <Table style={{}} className="table1" size="small" aria-label="a dense table">
            <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
              <TableRow>
                {columnDefs.map((col, index) => (
                  <TableCell key={`FTH-${index}`} style={{ fontSize: '13px' }}>
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                {columnDefs.map((col, index) =>
                  col.showfilter !== false ? (
                    <TableCell key={`FTH-${index}`} sx={{ minHeight: '36px', padding: '5px 2px' }}>
                      <div className="filter-input" style={{ fontSize: '10px', justifyContent: 'space-between' }}>
                        <input
                          id={`filter-${index}`}
                          className="field"
                          name="cancelSearchInput"
                          style={{ width: '100%' }}
                          placeholder={cs.contains}
                          onChange={(e) => {
                            handleChangeContain(e, col.field)
                          }}
                        />
                        <FilterAltIcon sx={{ paddingRight: '0px !important', color: '#aaa !important' }} />
                      </div>
                    </TableCell>
                  ) : (
                    <TableCell></TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody className="filter-data-row">
              {filteredData ? (
                filteredData?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell className="checkbox-ctrl">
                      <input type="radio" id={`checkbox_${item.BookingId}`} onChange={() => setSelectId(item.BookingId)} name="record" />
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px' }} title={item.LRNo}>
                        {item.LRNo}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px' }} title={item.FormattedLRNo}>
                        {item.FormattedLRNo}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px' }} title={item.ManualLRNo}>
                        {item.ManualLRNo}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px' }} title={item.LRStatus}>
                        {item.LRStatus}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px' }}>{item.CurrentCity}</span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px' }} title={item.BookingDateTime}>
                        {item.BookingDateTime}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span className={activeClassForLr(item.PaymentTypeDet)} title={item.PaymentTypeDet}>
                        {item.PaymentTypeDet}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px' }} title={item.Sender}>
                        {item.Sender}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px' }} title={item.RecName}>
                        {item.RecName}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px' }} title={item.FromCity}>
                        {item.FromCity}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px' }} title={item.ToCity}>
                        {item.ToCity}
                      </span>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <></>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
      <Stack>
        {/* confirm */}
        <div className="modal-btn-grp">
          <span style={{ display: 'flex', marginRight: '610px' }}>
            {paymentTypeColor.map((val, i) => {
              return (
                <>
                  <span
                    style={{ marginLeft: '10px', backgroundColor: val.color, width: '13px', height: '13px', borderRadius: '50%' }}
                  ></span>
                  <span style={{ padding: '0px 7px', fontSize: '12px' }}>{val.value}</span>
                </>
              )
            })}
          </span>
          <Button className="cancel-btn" variant="outlined" color="error" onClick={close}>
            {cs.cancel}
          </Button>
          <Button
            className="select-lr-btn"
            variant="contained"
            color="error"
            style={{ fontSize: '12px', whiteSpace: 'nowrap' }}
            onClick={() => SelectLrForDelivery()}
          >
            {rs.receiveLitLR}
          </Button>
        </div>
      </Stack>
    </>
  )
}
